import angular from "angular";

angular
    .module('ui-sentinel.geofences', [
        'LocalStorageModule',
        'api-sentinel',
        'ui-sentinel.maps',
    ]);
